export default "__VITE_ASSET__BTzXnBuM__"